import React, { ChangeEvent, useEffect, useState } from "react";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import IOnTypeaheadCatalogItemDTO from "../../../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import ITypeaheadCatalogItemDTO from "../../../../../models/DTO/ITypeaheadCatalogItemDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import ICatalog_Item from "../../../../../models/ICatalog_Item";
import IKit_Catalog_Items_MapUI from "../../../../../models/IKit_Catalog_Items_MapUI";
import INewKit_Catalog_Items_Map from "../../../../../models/INewKit_Catalog_Items_Map";
import INewKit_Catalog_Items_MapUI from "../../../../../models/INewKit_Catalog_Items_MapUI";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import OwCheckbox from "../../../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import Typeahead from "../../../../shared/Typeahead/Typeahead";
import "./KitDetail.scss";
import { Socket } from "socket.io-client";
import OwPill from "../../../../shared/OwPill/OwPill";

type Props = {
    mapItems: IKit_Catalog_Items_MapUI[];
    updateKitItemsFn: (items: (IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI)[]) => void;
    socket: Socket;
    notify: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    catalogGuid: string;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    hasKitBaseOptions: boolean;
    isAdvancedKit: boolean;
};

export const KitDetail: React.FC<Props> = (props) => {
    const [foundItems, setFoundItems] = useState<ICatalog_Item[] | undefined>();
    const [lookupActive, setLookupActive] = useState<boolean>(false);
    const [clearTypeahead, setClearTypeahead] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<ICatalog_Item | undefined>();
    const [mapItems, setMapItems] = useState<(IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI)[]>(props.mapItems);

    useEffect(() => {
        setMapItems(props.mapItems);
    }, [props.mapItems]);

    useEffect(() => {
        props.updateKitItemsFn(mapItems);
    }, [mapItems]);

    useEffect(() => {
        props.socket.on(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, onTypeaheadCatalogItem);

        return () => {
            props.socket.removeListener(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, onTypeaheadCatalogItem);
        };
    }, []);

    const typeaheadCatalogItem = (name: string) => {
        setLookupActive(true);

        const payload: ITypeaheadCatalogItemDTO = {
            catalogGuid: props.catalogGuid,
            userGuid: props.userModel.guid,
            userToken: props.userModel.token,
            supplierGuid: props.supplierModel.guid,
            name,
            onlyActive: true,
            options: {
                searchName: true,
                searchDescription: true,
                searchSku: true,
                searchUpc: true,
            },
            skipAlternateSourceFiltering: true,
            includeComponents: true,
        };

        props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
    };

    const onTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        // if (lookupActive) {
        setFoundItems(data.catalog_items);

        setLookupActive(false);
        // }
    };

    const selectedItemFn = (item: ICatalog_Item) => {
        const newKitCatalogItemMap: INewKit_Catalog_Items_MapUI = {
            catalog_item_id: item.id,
            qty_in_kit: 1,
            catalog_id: item.catalog_id,
            is_kit_base_option: false,
            Catalog_Item: item,
            order: mapItems.length + 1,
        };

        // console.log("init map items: ", mapItems);

        const existingItems = [...mapItems];

        // @ts-expect-error
        existingItems.push(newKitCatalogItemMap);

        // console.log("selectedItemFn: ", mapItems, existingItems);

        setMapItems((prevMapItems) => [...prevMapItems, newKitCatalogItemMap]);
    };

    const clearTypeaheadFn = () => {
        setClearTypeahead(false);
        setSelectedItem(undefined);
    };

    const deleteItem = (item: IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI, index: number) => {
        const existingItems = [...mapItems];

        if ("id" in item && item.id) {
            // @ts-expect-error
            existingItems[index].deleteFlag = true;
        } else {
            // splice the item. from the existing items.
        }

        setMapItems(existingItems);
    };

    const updateItem = (item: IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI, index: number, e: ChangeEvent<HTMLInputElement>) => {
        const existingItems = [...mapItems];

        switch (e.target.name) {
            case "qty_in_kit":
                existingItems[index].qty_in_kit = Number(e.target.value || 0);
                break;

            case "is_kit_base_option":
                existingItems[index].is_kit_base_option = !!e.target.value;
                break;

            case "hide":
                existingItems[index].hide = !!e.target.value;
                break;

            case "order":
                existingItems[index].order = Number(e.target.value || index);
                break;
        }

        setMapItems(existingItems);
    };

    const getPillDetail = (item: IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI) => {
        if (item.Catalog_Item?.is_kit) {
            return <OwPill title={"kit"} className={"ms-2"} />;
        }
    };

    const getCatalogItemPill = (item: ICatalog_Item) => {
        if (item.is_kit) {
            return <OwPill title={"kit"} className={"ms-2"} />;
        }
    };

    const renderKitItemLookup = (item: ICatalog_Item) => {
        return (
            <div>
                <div>
                    {item.name}
                    {getCatalogItemPill(item)}
                </div>
                <div className={"text-muted text-small"}>{item.sku}</div>
            </div>
        );
    };

    return (
        <div className={"KitDetail"}>
            <div>
                <Typeahead
                    isSelectableFn={() => true}
                    typeaheadApiFn={typeaheadCatalogItem}
                    itemsRenderFn={renderKitItemLookup}
                    titleProp={"sku"}
                    subTitleProp={"name"}
                    confirmAdd={true}
                    typeaheadItems={foundItems}
                    selectedItem={selectedItem}
                    selectedItemFn={selectedItemFn}
                    selectedItemTitleProp={"name"}
                    clearTypeahead={clearTypeahead}
                    clearTypeaheadCallback={clearTypeaheadFn}
                    scrollableList={true}
                />
            </div>

            <div className={"mt-2"}>
                <div className={"d-flex"}>
                    <div className={"w-10 text-center"}>
                        <OwLabel title={"order"} />
                    </div>
                    <div className={"w-60"}>
                        <OwLabel title={"sku"} />
                    </div>
                    {props.hasKitBaseOptions ? (
                        <div className={"w-10 text-center"}>
                            <OwLabel title={"base_option"} />
                        </div>
                    ) : null}
                    {props.isAdvancedKit ? (
                        <div className={"w-10 text-center"}>
                            <OwLabel title={"hide"} />
                        </div>
                    ) : null}
                    <div className={"w-10 text-end"}>
                        <OwLabel title={"qty"} />
                    </div>
                </div>
                <div className={"kit-detail-rows"}>
                    {mapItems.map((item, index) => {
                        if ("deleteFlag" in item && item.deleteFlag) {
                            return null;
                        } else {
                            return (
                                <div className={"d-flex mt-2 p-2"} key={index}>
                                    <div className={"w-10 text-center"}>
                                        <OwInputWrapper
                                            name={"order"}
                                            value={item.order}
                                            fn={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                updateItem(item, index, e);
                                            }}
                                        />
                                    </div>
                                    <div className={"w-60 ms-1"}>
                                        <i
                                            className={"fad fa-trash-alt text-danger pointer me-2"}
                                            onClick={() => {
                                                deleteItem(item, index);
                                            }}
                                        />
                                        {item.Catalog_Item?.name}
                                        {getPillDetail(item)}
                                    </div>
                                    {props.hasKitBaseOptions ? (
                                        <div className={"w-10 text-center"}>
                                            <OwCheckbox
                                                fn={(e) => updateItem(item, index, e)}
                                                truthyVal={true}
                                                falsyVal={false}
                                                name={"is_kit_base_option"}
                                                checked={item.is_kit_base_option}
                                            />
                                        </div>
                                    ) : null}
                                    {props.isAdvancedKit ? (
                                        <div className={"w-10 text-center"}>
                                            <OwCheckbox
                                                fn={(e) => updateItem(item, index, e)}
                                                truthyVal={true}
                                                falsyVal={false}
                                                name={"hide"}
                                                checked={item.hide}
                                            />
                                        </div>
                                    ) : null}
                                    <div className={"w-10 text-end"}>
                                        <OwInputWrapper
                                            name={"qty_in_kit"}
                                            value={item.qty_in_kit}
                                            fn={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                updateItem(item, index, e);
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        }
                    })}
                </div>
            </div>
        </div>
    );
};
